import { gql, useQuery } from "@apollo/client";
import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DownloadExcel } from "src/components/DownloadExcel";
import { Pagination } from "src/components/pagination";
import HeaderTable from "src/components/table/HeaderTable";
import { Graph } from "src/generated/graph";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Loading } from "../../components/Loading";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Dashboard",
    to: "/",
  },
  {
    text: "Total hold",
    to: "/dashboard/hold",
  },
];

const headerDisplay = [
  {
    label: "PRODUCT",
    className: "text-center",
  },
  {
    label: "COLOR",
    className: "text-center",
  },
  {
    label: "SIZE",
    className: "text-center",
  },
  {
    label: "QTY",
    className: "text-center",
  },
  {
    label: "SALE",
    className: "text-right",
  },
  {
    label: "DELIVERY FEE",
    className: "text-right",
  },
  {
    label: "HANDLING FEE",
    className: "text-right",
  },
  {
    label: "COMMISSION",
    className: "text-right",
  },
  {
    label: "NET SALE",
    className: "text-right",
  },
  {
    label: "ORDER DATE",
    className: "text-right",
  },
];

const query_merchant_hold_detail = gql`
  query supplierOrderBalance($offset: Int = 0, $limit: Int = 100) {
    supplierOrderBalance(offset: $offset, limit: $limit, status: HOLD) {
      data
      page {
        current
        size
        total
      }
    }
  }
`;

function Body({ supplierHoldBalance, select }: { supplierHoldBalance: any; select: any[] }) {
  const data = supplierHoldBalance;
  return (
    <tbody>
      {data?.map((x: any, i: number) => {
        return (
          <tr key={i}>
            <td style={{ width: 10 }}>{i + 1}</td>
            {select.findIndex((x) => x.label === "PRODUCT") >= 0 && (
              <td rowSpan={x.sku.length} className="text-center">
                <div>
                  <div
                    style={{
                      backgroundImage: `url("${x.picture}")`,
                      width: 50,
                      height: 50,
                      backgroundSize: "cover",
                      borderRadius: 4,
                      margin: "auto",
                    }}
                  ></div>
                  <div style={{ fontSize: 10, textAlign: "center" }}>
                    <span>{x.order_uuid}</span>
                    <br />
                    {x.supplier_code}
                    <br />
                    <span>Order Date: {moment(x.order_date).format("YYYY-MM-DD")}</span>
                    <br />
                    <Link to="#">L192: {x.code}</Link>
                  </div>
                </div>
              </td>
            )}
            {select.findIndex((x) => x.label === "COLOR") >= 0 && <td className="text-center">{x.sku.option1}</td>}
            {select.findIndex((x) => x.label === "SIZE") >= 0 && <td className="text-center">{x.sku.option2}</td>}
            {select.findIndex((x) => x.label === "QTY") >= 0 && <td className="text-center">{x.sku.stockQty}</td>}
            {select.findIndex((x) => x.label === "SALE") >= 0 && (
              <td className="text-right text-success">${x.full_price}</td>
            )}
            {select.findIndex((x) => x.label === "DELIVERY FEE") >= 0 && (
              <td className="text-right text-danger"> -${Number(x.delivery_fee).toFixed(2)}</td>
            )}
            {select.findIndex((x) => x.label === "HANDLING FEE") >= 0 && (
              <td className="text-right text-danger"> -${Number(x.handling_fee).toFixed(2)}</td>
            )}
            {select.findIndex((x) => x.label === "COMMISSION") >= 0 && (
              <td className="text-right text-danger"> -${Number(x.l192_commission).toFixed(2)}</td>
            )}
            {select.findIndex((x) => x.label === "NET SALE") >= 0 && (
              <td className="text-right text-success">
                {" "}
                $
                {(
                  Number(x.full_price) -
                  (Number(x.delivery_fee) + Number(x.handling_fee) + Number(x.l192_commission))
                ).toFixed(2)}
              </td>
            )}
            {select.findIndex((x) => x.label === "ORDER DATE") >= 0 && (
              <td className="text-right">{moment(new Date(x.ordered_date)).format("YYYY-MM-DD")}</td>
            )}
          </tr>
        );
      })}
    </tbody>
  );
}

export function HoldDetailScreen(props: any) {
  const [, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(0);
  const [select, setSelect] = useState(
    headerDisplay.map((x) => {
      return {
        label: x.label,
        value: x.label,
      };
    }),
  );
  const { data, loading } = useQuery<Graph.Query>(query_merchant_hold_detail, {
    fetchPolicy: "no-cache",
    variables: {
      offset: offset * Number(limit),
      limit: Number(limit),
    },
    onCompleted: (res) => {
      let total = 0;
      if (res.supplierOrderBalance?.data.length > 0) {
        for (const item of res.supplierOrderBalance?.data) {
          total =
            total +
            (Number(item.price) - (Number(item.deliveryFee) + Number(item.handlingFee) + Number(item.commission)));
        }
      }
      setTotal(total);
    },
  });

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock title="Total Balance Detail" transparent={true}>
          <Loading />
        </SectionBlock>
      </Content>
    );
  }

  const headers = select.map((x) => {
    const res = headerDisplay.find((f) => f.label === x.label);
    return {
      label: x.label,
      className: res?.className,
    };
  });

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <SectionBlock title="Total Balance Detail">
        <DownloadExcel
          query={query_merchant_hold_detail}
          option={{
            fetchPolicy: "no-cache",
            variables: {
              offset: 0,
              limit: 1000000,
            },
          }}
          queryName="supplierOrderBalance"
        />
        <br />
        <br />
        <div className="table-responsive">
          <div className="dataTables_wrapper container-fluid dt-bootstrap4">
            <div className="row">
              <div className="col-sm-12">
                <table className="table table-bordered table-lg table-v2 table-striped dataTable">
                  <HeaderTable
                    {...props}
                    offset={offset}
                    setOffset={setOffset}
                    limit={limit}
                    setLimit={setLimit}
                    totalPage={data.supplierOrderBalance?.page?.total}
                    sort={"x"}
                    sortDirection={"ASC"}
                    items={headers}
                    select={select}
                    setSelect={setSelect}
                    options={headerDisplay.map((x) => {
                      return {
                        label: x.label,
                        value: x.label,
                      };
                    })}
                  />
                  <tfoot>
                    <tr>
                      <th colSpan={select.length + 1} style={{ padding: 12 }}>
                        <Pagination
                          props={props}
                          offset={offset}
                          setOffset={setOffset}
                          total={data.supplierOrderBalance?.page?.total}
                          limit={limit}
                          setLimit={setLimit}
                          display="FLEX"
                        />
                      </th>
                    </tr>
                  </tfoot>
                  <Body supplierHoldBalance={data.supplierOrderBalance!.data} select={select} />
                </table>
              </div>
            </div>
          </div>
        </div>
      </SectionBlock>
    </Content>
  );
}
